export function loginNotificationToExt (refresh_token: string) {
    const LOGIN_REFRESH_TOKEN = "CE_REFRESH_TOKEN";
    window.postMessage({
        type: LOGIN_REFRESH_TOKEN,
        payload: refresh_token
    }, window.location.origin);
};
